import React, { ReactElement, lazy } from 'react';
import { BOARD_TYPE } from '@typings/boardType';
import {
  masterSet,
  masterHomeSet,
} from '@masterSetting/masterSet/masterSetting';
import { ACCESS_TYPE, ACCESS_TYPE_VALUE } from '@typings/common/accessType';
import { CollectionPath } from '@typings/collections.enum';

const Home = lazy(() => import('@pages/MainHome'));

const RelationshipPage = lazy(
  () => import('@pages/ETC/Relationship/RelationshipPage'),
);

// setting
const SettingPage = lazy(() => import('@pages/Setting/SettingPage'));

const UserSetting = lazy(() => import('@pages/UserSetting'));
const UserDetailPage = lazy(() => import('@pages/UserSetting/UserDetail'));
const MemberPage = lazy(() => import('@pages/Setting/1.Member/MemberPage'));

// gallery
const Gallery = lazy(() => import('@pages/Gallery/Gallery'));
const GalleryDetail = lazy(() => import('@pages/Gallery/Detail/GalleryDetail'));

// photocard
const PhotoCard = lazy(() => import('@pages/PhotoCard'));
const PhotoCardDetail = lazy(
  () => import('@pages/PhotoCard/PhotoCardDetail/PhotocardDetail'),
);
// couple
const CouplePage = lazy(() => import('@pages/Couple'));
const CoupleDetail = lazy(() => import('@pages/Couple/CoupleDetail'));
const EditCouple = lazy(() => import('@pages/Couple/EditCouple'));

// guestbook
const GuestBookPage = lazy(() => import('@pages/GuestBook'));
const GuestbookBoardDetail = lazy(
  () => import('@pages/GuestBook/BoardType/BoardDetail'),
);

// calender
const CalendarPage = lazy(() => import('@pages/Calendar'));

// challenge
const ChallengeDetailPage = lazy(
  () => import('@pages/Challenge/ChallengeDetail'),
);

// timeline
const TimelinePage = lazy(() => import('@pages/Timeline'));
const TimelineDetail = lazy(() => import('@pages/Timeline/TimelineDetail'));
const RollplayDetail = lazy(
  () => import('@pages/Timeline/RollplayDetail/RollPlayDetail'),
);

// threads - 새로운 스레드 게시판
const ThreadsPage = lazy(() => import('@pages/Threads/ThreadsPage'));
const ThreadDetail = lazy(
  () => import('@pages/Threads/ThreadDetail/ThreadDetail'),
);
const ThreadQuotesPage = lazy(
  () => import('@pages/Threads/ThreadQuotesPage'),
);
// const EditThreadPage = lazy(() => import('@pages/Threads/EditThread/EditThreadPage'));

// posting
const PostingPage = lazy(() => import('@pages/Posting/Posting'));
const EditPostingPage = lazy(
  () => import('@pages/Posting/EditPosting/EditPosting'),
);
const PostingDetail = lazy(
  () => import('@pages/Posting/PostingDetail/PostingDetail'),
);

// trpg
const TRPGPage = lazy(() => import('@pages/Trpg'));
const TRPGDetail = lazy(() => import('@pages/Trpg/trpgDetail/TrpgDetail'));
const EditTrpgPage = lazy(() => import('@pages/Trpg/EditPage'));

//series
const SeriesPage = lazy(() => import('@pages/Series/SeriesPage'));

// stickerboard
const StickerBoard = lazy(() => import('@pages/StickerBoard/Stickerboard'));
const StickerDetailPage = lazy(
  () => import('@pages/StickerBoard/StickerDetail'),
);

// InteractiveStory
const InteractiveStoryPage = lazy(() => import('@pages/InteractiveStory'));
const InteractiveStoryDetail = lazy(
  () =>
    import(
      '@pages/InteractiveStory/InteractiveStoryDetail/InteractiveStoryDetail'
    ),
);
const InteractiveStoryAdmin = lazy(
  () => import('@pages/InteractiveStory/InteractiveStoryAdmin/AdminPage'),
);
const UpdateInteractiveStoryModal = lazy(
  () =>
    import(
      '@pages/InteractiveStory/UpdateInteractiveStory/UpdateInteractiveStoryModal'
    ),
);
const Chat = lazy(() => import('@pages/Chat/ChatPage'));
const StoryReadonlyPage = lazy(
  () => import('@pages/GuestBook/StoryType/StoryReadonly/StoryReadonlyPage'),
);
const FormSettingPage = lazy(
  () => import('@pages/Form/setting/FormSettingPage'),
);
const FormBulkManagePage = lazy(
  () => import('@pages/Form/manage/FormBulkManagePage'),
);
const PetView = lazy(() => import('@pages/Pets/PetView/PetView'));
const BettingPage = lazy(() => import('@pages/Betting'));

// reset-password
const ResetPasswordPage = lazy(
  () => import('@pages/Register/ResetPassword/ResetPasswordPage'),
);

// drawing tool
const DrawingToolPage = lazy(() => import('@pages/DrawingTool/DrawingToolPage'));

// memo
const MemoPage = lazy(() => import('@pages/Memo'));
const MemoDetailPage = lazy(() => import('@pages/Memo/detail/MemoDetailPage'));

// world
const WorldPage = lazy(() => import('@pages/World'));
const WorldEditPage = lazy(() => import('@pages/World/edit/WorldEditPage'));
const WorldDetailEditPage = lazy(
  () => import('@pages/World/edit/WorldDetailEditPage'),
);
const WorldDetailPage = lazy(
  () => import('@pages/World/detail/WorldDetailPage'),
);

// history
const HistoryPage = lazy(() => import('@pages/History/HistoryPage'));
const HistoryEditPage = lazy(
  () => import('@pages/History/edit/HistoryEditPage'),
);
const HistoryDetailPage = lazy(
  () => import('@pages/History/detail/DetailHistoryPage'),
);

// Store
const StorePage = lazy(() => import('@pages/Store/StorePage'));
const StoreEditPage = lazy(() => import('@pages/Store/edit/StoreEditPage'));
const StoreNpcEditPage = lazy(
  () => import('@pages/Store/NPC/edit/NPCEditPage'),
);
const LuckyDrawEditPage = lazy(
  () => import('@pages/Store/LuckyDraw/edit/LuckyDrawEditPage'),
);
const StoreDetailPage = lazy(
  () => import('@pages/Store/history/StoreDetailPage'),
);

// calculate
const CalculatePage = lazy(() => import('@pages/Calculate/CalculatePage'));

// exploration
const ExplorationPage = lazy(
  () => import('@pages/Exploration/ExplorationPage'),
);
const ExplorationEditPage = lazy(
  () => import('@pages/Exploration/edit/ExplorationEditPage'),
);

// raid
const RaidPage = lazy(() => import('@pages/Raid/RaidPage'));
const RaidEditPage = lazy(() => import('@pages/Raid/edit/RaidEditPage'));
const RaidDetailPage = lazy(() => import('@pages/Raid/detail/RaidDetailPage'));

// worldmap
const WorldMapPage = lazy(() => import('@pages/WorldMap/WorldMapPage'));
const WorldMapEditPage = lazy(
  () => import('@pages/WorldMap/edit/WorldMapEditPage'),
);
const WorldMapDetailPage = lazy(
  () => import('@pages/WorldMap/detail/WorldMapDetailPage'),
);

//banner
const BannerPage = lazy(
  () => import('@pages/MainHome/BannerSec/BannerPage/index'),
);

// form
const FormPage = lazy(() => import('@pages/Form/FormPage'));
const FormEditPage = lazy(() => import('@pages/Form/edit/FormEditPage'));
const FormDetailPage = lazy(() => import('@pages/Form/detail/FormDetailPage'));

// quest
const QuestPage = lazy(() => import('@pages/Quest/QuestPage'));
const QuestLogDetail = lazy(() => import('@pages/Quest/QuestLogDetail'));

// my-page setting
const MyPageSettingPage = lazy(
  () => import('@pages/MyPageSetting/MyPageSettingPage'),
);

// dev
const EditorTestPage = lazy(() => import('@pages/Dev/EditorTestPage'));

export enum RootPath {
  Main = '/',
  Register = '/register',
  SignUp = '/signup',
  Support = '/support',

  ResetPassword = '/reset-password',

  HashtagSearchResult = '/hashtag-search-result',
  User = '/user',
  Series = '/series',
  Chat = '/chat',
  Relationship = '/relationship',
  Banners = '/banners',
  NPC = '/npc',
  // ---------------------------------------------
  // main menu Route
  // ---------------------------------------------
  World = 'world',
  History = 'history',
  Setting = 'setting',
  GuestbookStory = 'guestbook-story',

  // ---------------------------------------------
  // edit page
  // ---------------------------------------------

  PhotoCardEdit = '/photocard-edit',
  TimelineEdit = '/timeline-edit',
  MakeBoard = '/make-board',
  EditPosting = '/edit-posting',
  EditCouple = '/edit-couple',
  EditTrpg = '/edit-trpg',

  // 멤버 -----------------------------------------
  MemberManagement = 'member-management',
  MemberAuth = 'member-auth',
  MemberTitle = 'member-title',
  UserAccountTab = 'user-account-tab',

  // 메인 홈 -----------------------------------------
  MainHome = 'mainhome-setting',
  Notice = 'notice',
  BannerEdit = 'banner-edit',
  Slider = 'slider-edit',
  DdayWidget = 'dday-widget',
  WidgetManagement = 'widget-management',
  GatePage = 'gate-page',
  BackgroundEffect = 'background-effect',
  Simeji = 'simegi',
  StickerSetting = 'sticker-setting',

  // 게시판별 기능 -----------------------------------------
  BoardTag = 'board-tag',
  Emoticon = 'emoticon-settings',
  DefaultPhotoCard = 'photocard-default',
  Form = 'form-settings',
  CustomBot = 'custom-bot-settings',
  TimelineSetting = 'timeline-setting',
  ThreadsSetting = 'threads-setting',
  GuestbookSetting = 'guestbook-setting',
  StickerDocSetting = 'stickerboard-setting',
  CalculateSetting = 'calculate-setting',
  BoardWritePermission = 'board-write-permission',

  // 홈페이지 설정 -----------------------------------------
  Home = 'home',
  HomepageDesign = 'homepage-design',
  AsideDesign = 'aside-design',
  Common = 'common-setting',
  Board = 'board',
  Homepage = 'homepage',
  Mouse = 'mouse',
  Music = 'music',
  SoundEffect = 'sound-effect',
  ThemaManager = 'theme-manager',
  FontManager = 'font-manager',
  PopupManagement = 'popup-management',
  NotificationSetting = 'notification-setting',

  // 재화 & 아이템 -----------------------------------------
  ItemManagement = 'item-management',
  CurrencyManager = 'currency-manager',
  NPCManager = 'npc-manager',
  ParchaseHistory = 'parchase-history',

  // 커뮤니티 -----------------------------------------
  CummunityManager = 'cummunity-manager',
  RandomDraw = 'random-draw',
  CommunityManager = 'community-design',
  Status = 'status',
  Skills = 'skills',
  EquipmentSetting = 'equipment-setting',
  PetSystem = 'pet-system',
  Battle = 'battle',
  Monster = 'monster',
  MapManagement = 'map-management',
  Exploration = 'exploration',
  Pet = 'pet',
  Quest = 'quest',
  Betting = 'betting',
  // ---------------------------------------------
  // user (MYPAGE)
  // ---------------------------------------------
  MyPosting = 'myPosting',
  MyTimeline = 'myTimeline',
  MyInfo = 'myInfo',
  MySeries = 'mySeries',
  MyBookmark = 'myBookmark',
  MyPhotoCard = 'myPhotocard',
  MyFormList = 'myFormList',
  MyCalculate = 'myCalculate',
  MyStatus = 'myStatus',
  MyCharacter = 'myCharacter',
  MyPet = 'myPet',
  MyQuest = 'myQuest',
  MyBetting = 'myBetting',
  MyWalletHistory = 'myWalletHistory',
  MyItemHistory = 'myItemHistory',
  UserDetail = 'userDetail',
  // 위험 구간 -----------------------------------------
  DeleteAllPosting = 'delete-all-posting',
  DmAdmin = 'dm-admin',
  ApiIntegration = 'api-integration',
  BackupData = 'backup-data',

  // 개인 유저 설정 -----------------------------------------
  MyPageSetting = 'my-setting',
  MyPageNotification = 'notification',
  MyPageAccountInfoChange = 'account-info-change',
  MyPageStandingCharacter = 'standing-character',
  MyPageAccountWithdrawal = 'account-withdrawal',

  // 외부 임베드 -----------------------------------------
  NotionEmbed = 'notion-embed',

  // 개발 테스트 -----------------------------------------
  DevEditorTest = '/dev/editor-test',
}

interface IRouteList {
  path: string;
  component: ReactElement;
  accessType: ACCESS_TYPE_VALUE;
}

export const fixedtRouteList: IRouteList[] = [
  {
    path: `${RootPath.Series}/:id/:id2`,
    component: <SeriesPage />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${RootPath.ResetPassword}`,
    component: <ResetPasswordPage />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${RootPath.User}/:id/${RootPath.UserDetail}/*`,
    component: <UserDetailPage />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${RootPath.User}/:id/*`,
    component: <UserSetting />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${RootPath.User}`,
    component: <UserSetting />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: RootPath.Banners,
    component: <BannerPage />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${RootPath.MyPageSetting}/*`,
    component: <MyPageSettingPage />,
    accessType: ACCESS_TYPE.MEMBER,
  },
  {
    path: `${RootPath.Setting}/*`,
    component: <SettingPage />,
    accessType: ACCESS_TYPE.SECRET,
  },
  {
    path: RootPath.MemberManagement,
    component: <MemberPage />,
    accessType: ACCESS_TYPE.SECRET,
  },
  {
    path: RootPath.Relationship, // 테스트중
    component: <RelationshipPage />,
    accessType: ACCESS_TYPE.SECRET,
  },
  {
    path: `${RootPath.Chat}/*`, // 테스트중
    component: <Chat />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${CollectionPath.QUEST_LOG}/image/:docId/:photoIndex`,
    component: <QuestLogDetail />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${CollectionPath.QUEST_LOG}/:docId`,
    component: <QuestLogDetail />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  {
    path: `${RootPath.NPC}/*`,
    component: <PhotoCardDetail />,
    accessType: ACCESS_TYPE.PUBLIC,
  },
  ...(masterSet.drawingtool
    ? [
        {
          path: '/drawing-tool',
          component: <DrawingToolPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ]
    : []),
  // dev
  {
    path: RootPath.DevEditorTest,
    component: <EditorTestPage />,
    accessType: ACCESS_TYPE.SECRET,
  },
];

export const extractModalRoutePath = (typeName, path) => {
  switch (typeName) {
    case BOARD_TYPE.INTERACTIVE_STORY:
      return [
        {
          path: `/${path}/edit/*`,
          component: <UpdateInteractiveStoryModal />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}/edit`,
          component: <UpdateInteractiveStoryModal />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    default:
      break;
  }
};

export const extrarctRoutePath = (typeName, path) => {
  switch (typeName) {
    case BOARD_TYPE.POSTING:
      return [
        {
          path: `/${path}/*`,
          component: <PostingDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <EditPostingPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit`,
          component: <EditPostingPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <PostingPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.PHOTOCARD:
      return [
        {
          path: `/${path}/*`,
          component: <PhotoCardDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}Posting/*`,
          component: <PostingDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}Posting-edit/*`,
          component: <EditPostingPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <PhotoCard />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.GALLERY:
      return [
        {
          path: `/${path}/*`,
          component: <GalleryDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <Gallery />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;

    case BOARD_TYPE.TIMELINE:
      return [
        {
          path: `/${path}/*`,
          component: <RollplayDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}/image/*`,
          component: <TimelineDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },

        {
          path: `/${path}Comment/*`,
          component: <RollplayDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <TimelinePage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.COUPLE:
      return [
        {
          path: `/${path}/*`,
          component: <CoupleDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <EditCouple />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <CouplePage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.TRPG:
      return [
        {
          path: `/${path}/*`,
          component: <TRPGDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <EditTrpgPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit`,
          component: <EditTrpgPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <TRPGPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.GUESTBOOK:
      return [
        {
          path: `/${path}/*`,
          component: <GuestbookBoardDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}/story/*`,
          component: <StoryReadonlyPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <GuestBookPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.MEMO:
      return [
        {
          path: `/${path}/*`,
          component: <MemoDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <MemoPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.STICKERBOARD:
      return [
        {
          path: `/${path}/:id`,
          component: <StickerDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <StickerBoard />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.INTERACTIVE_STORY:
      return [
        {
          path: `/${path}/:id/admin`,
          component: <InteractiveStoryAdmin />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}/*`,
          component: <InteractiveStoryDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <InteractiveStoryPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.CALENDAR:
      return [
        {
          path: `/${path}`,
          component: <CalendarPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${CollectionPath.CHALLENGE}2/*`,
          component: <ChallengeDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${CollectionPath.CHALLENGE}/*`,
          component: <ChallengeDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.CHALLENGE:
      return [
        {
          path: `/${path}/*`,
          component: <ChallengeDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.HOME:
      return [
        {
          path: `/${path}`,
          component: <Home />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.WORLD:
      return [
        {
          path: `/${path}/*`,
          component: <WorldDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <WorldEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-detailedit/*`,
          component: <WorldDetailEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <WorldPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.HISTORY:
      return [
        {
          path: `/${path}/*`,
          component: <HistoryDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <HistoryEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <HistoryPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.STORE:
      return [
        {
          path: `/${path}-history`,
          component: <StoreDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-npc`,
          component: <StoreNpcEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-luckydraw`,
          component: <LuckyDrawEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <StoreEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <StorePage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.CALCULATE:
      return [
        {
          path: `/${path}/*`,
          component: <CalculatePage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <CalculatePage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.RAID:
      return [
        {
          path: `/${path}/*`,
          component: <RaidDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <RaidEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <RaidPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.WORLDMAP:
      return [
        {
          path: `/${path}/*`,
          component: <WorldMapDetailPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <WorldMapEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <WorldMapPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.EXPLORATION:
      return [
        {
          path: `/${path}/*`,
          component: <ExplorationPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}-edit/*`,
          component: <StoreEditPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <ExplorationPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.FORM:
      return [
        {
          path: `/${path}-edit/*`,
          component: <FormEditPage />,
          accessType: ACCESS_TYPE.SECRET,
        },
        {
          path: `/${path}-result/*`,
          component: <FormDetailPage />,
          accessType: ACCESS_TYPE.SECRET,
        },
        {
          path: `/${path}-setting`,
          component: <FormSettingPage />,
          accessType: ACCESS_TYPE.SECRET,
        },
        {
          path: `/${path}-manage`,
          component: <FormBulkManagePage />,
          accessType: ACCESS_TYPE.SECRET,
        },
        {
          path: `/${path}/*`,
          component: <FormEditPage />,
          accessType: ACCESS_TYPE.SECRET,
        },
        {
          path: `/${path}`,
          component: <FormPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.THREADS:
      return [
        {
          path: `/${path}/:threadId/quotes`,
          component: <ThreadQuotesPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}/:threadId`,
          component: <ThreadDetail />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
        {
          path: `/${path}`,
          component: <ThreadsPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.PET:
      return [
        {
          path: `/${path}/*`,
          component: <PetView />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.QUEST:
      return [
        {
          path: `/${path}/*`,
          component: <QuestPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    case BOARD_TYPE.BETTING:
      return [
        {
          path: `/${path}/*`,
          component: <BettingPage />,
          accessType: ACCESS_TYPE.PUBLIC,
        },
      ];
      break;
    default:
      console.log(`${typeName}과 일치하는 게시판이 없습니다.`);
  }
};

export function setRoute({ data }) {
  let res: any[] = [];

  if (!data) return null;

  data.forEach((board, i) => {
    const results = extrarctRoutePath(board.typeName, board.path);
    if (!results) return null;

    results.forEach((result) => {
      res.push(result);
    });
  });

  return res;
}

export function setModalRoute() {
  let res: any[] = [];

  masterSet.boardSet.forEach((board, i) => {
    const results = extractModalRoutePath(board.typeName, board.path);
    if (!results) return null;

    results.forEach((result) => {
      res.push(result);
    });
  });

  return res;
}

export function setHomeRoute() {
  return extrarctRoutePath(masterHomeSet.typeName, masterHomeSet.path);
}
